<div
   class="screens-only"
   *ngIf="template?.sections?.length">
   <div
      class="review-section grid-container"
      *ngFor="let sectionGroup of sectionGroups; trackBy: trackBySectionGroup">
      <vc-rounded-card
         style="flex: 1"
         *ngIf="shouldShowSectionGroup(sectionGroup) && showSectionGroup(sectionGroup)">
         <div class="section-header">
            <h3 *ngIf="mode === 'reviewee'">{{ cardTitle(sectionGroup, "reviewee") }}</h3>
            <h3 *ngIf="mode === 'reviewer'">{{ cardTitle(sectionGroup, "reviewer") }}</h3>
            <h3 *ngIf="mode === 'merged'">{{ cardTitle(sectionGroup, "reviewee") }} / {{ cardTitle(sectionGroup, "reviewer") }}</h3>

            <span
               style="align-self: baseline"
               *ngIf="mode === 'reviewer' && sectionGroup[0].id == 'section_growth_and_career_path'">
               <button
                  *ngIf="canEdit('reviewer')"
                  type="button"
                  class="v-button v-button-md v-green"
                  (click)="hideExplorationSection()">
                  <i
                     class="fas"
                     [class.fa-ban]="includeCareerExploration"
                     [class.fa-check]="!includeCareerExploration"></i>
                  &nbsp;
                  {{ includeCareerExploration ? "Exclude Section" : "Include Section" }}
               </button>
            </span>
         </div>

         <div
            class="not-applicable-banner"
            *ngIf="mode === 'reviewer' && sectionGroup[0].id == 'section_growth_and_career_path' && !includeCareerExploration">
            <i class="fa-solid fa-ban"></i>
            <span>This section has been marked as not applicable for this review.</span>
         </div>

         <div
            class="d-flex flex-row flex-nowrap mt-0 gap-3 assess-card"
            [class.hidden-sub-section]="!includeCareerExploration && sectionGroup[0].id == 'section_growth_and_career_path'"
            [class.uhidden-sub-section]="includeCareerExploration && sectionGroup[0].id == 'section_growth_and_career_path'"
            [class.merged]="mode === 'merged'">
            <!-- Reviewee column -->
            <div
               *ngIf="mode !== 'reviewer'"
               style="flex: 1"
               class="left">
               <ng-container *ngFor="let section of sectionGroup; trackBy: trackBySectionId">
                  <div
                     class="section-subheader"
                     *ngIf="sectionGroup.length > 1 && section.id !== 'section_clinical_skills_intro' && shouldShowSection(section)">
                     <h4
                        class="review-subtitle"
                        style="margin-bottom: 20px">
                        {{ groupedSectionTitle(section, "reviewee") }}
                     </h4>

                     <button
                        *ngIf="section.allowSectionNotApplicable && canEdit('reviewee')"
                        type="button"
                        class="v-button v-button-md v-green"
                        (click)="markSectionNotApplicable(section, 'reviewee')">
                        Mark Not Applicable
                     </button>
                  </div>

                  <!-- DYNAMIC ADDITIONAL RESPONSIBILITIES - REVIEWEE -->
                  <ng-container *ngIf="isAdditionalResponsibilitiesSection(section)">
                     <div
                        class="item-group-assessment"
                        *ngFor="let r of additionalResponsibilities; trackBy: trackByResponsibilityId">
                        <vc-radio-group
                           [id]="'additional_responsibility_reviewee_' + r.id"
                           [groupName]="'additional_responsibility_reviewee_' + r.id"
                           direction="row"
                           [required]="true"
                           [disabled]="!canEdit('reviewee')"
                           [radiobutton]="true"
                           [label]="r.responsibilityText"
                           [options]="performanceOptions"
                           [ngModel]="getValue('additional_responsibility_' + r.id, 'reviewee')"
                           (ngModelChange)="setValue('additional_responsibility_' + r.id, 'reviewee', $event)"></vc-radio-group>
                        <div style="height: 5px"></div>
                        <vc-textarea
                           [label]="additionalResponsibilityRequiresNotes(r.id, 'reviewee') ? 'Please explain why' : 'Optional notes'"
                           [required]="additionalResponsibilityRequiresNotes(r.id, 'reviewee')"
                           [disabled]="!canEdit('reviewee')"
                           placeholder="Additional comments..."
                           [maxlength]="1000"
                           [ngModel]="getNotes('additional_responsibility_' + r.id, 'reviewee')"
                           (ngModelChange)="setNotes('additional_responsibility_' + r.id, 'reviewee', $event)"></vc-textarea>
                     </div>
                  </ng-container>

                  <ng-container *ngFor="let q of section.questions">
                     <!-- STATIC / READ-ONLY TEXT -->
                     <div
                        class="item-group-assessment static-review-text"
                        *ngIf="q.type === 'static' && hasText(q.revieweeLabel)"
                        [innerHTML]="questionLabel(q, 'reviewee')"></div>

                     <!-- RADIO -->
                     <div
                        class="item-group-assessment"
                        [attr.id]="section.id + '_' + q.id + '_reviewee'"
                        [class.has-error]="validationErrors.has(modeKey('reviewee', section.id, q.id))"
                        *ngIf="q.type === 'radio' && hasText(q.revieweeLabel)">
                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewee')"></div>
                        <vc-radio-group
                           [id]="'rg_' + section.id + '_' + q.id"
                           direction="row"
                           [required]="q.required"
                           [disabled]="!canEdit('reviewee')"
                           [radiobutton]="true"
                           [groupName]="'reviewee_' + section.id + '_' + q.id"
                           [label]="!q.labelIsHtml ? questionLabel(q, 'reviewee') : ''"
                           [options]="radioOptions(q, 'reviewee')"
                           [ngModel]="getValue(q.id, 'reviewee')"
                           (ngModelChange)="setValue(q.id, 'reviewee', $event)"></vc-radio-group>
                        <div style="height: 5px"></div>
                        <vc-textarea
                           *ngIf="q.notes?.revieweeLabel"
                           [id]="'notes_' + section.id + '_' + q.id"
                           [label]="getNotesLabel(q, 'reviewee')"
                           [required]="shouldRequireNotes(q, 'reviewee')"
                           [disabled]="!canEdit('reviewee')"
                           placeholder="Additional comments..."
                           [maxlength]="q.notes.maxLength || 500"
                           [ngModel]="getNotes(q.id, 'reviewee')"
                           (ngModelChange)="setNotes(q.id, 'reviewee', $event)"></vc-textarea>
                     </div>

                     <!-- CHECKBOX -->
                     <div
                        class="item-group-assessment"
                        [attr.id]="section.id + '_' + q.id + '_reviewee'"
                        [class.has-error]="validationErrors.has(modeKey('reviewee', section.id, q.id))"
                        *ngIf="
                           q.type === 'checkbox' &&
                           hasText(q.revieweeLabel) &&
                           !questionLabel(q, 'reviewee')?.includes('Job Description Not Available')
                        ">
                        <div
                           class="vc-label"
                           *ngIf="!q.labelIsHtml">
                           {{ questionLabel(q, "reviewee") }}
                           <span class="required-asterisk">*</span>
                        </div>

                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewee')"></div>

                        <div class="checkbox-grid">
                           <vc-checkbox
                              *ngFor="let opt of q.options"
                              [label]="opt.label"
                              [disabled]="
                                 !canEdit('reviewee') ||
                                 isLimitReached(q, 'reviewee', opt.value) ||
                                 questionLabel(q, 'reviewee')?.includes('Job Description Coming Soon')
                              "
                              [ngModel]="isChecked(q.id, 'reviewee', opt.value)"
                              (ngModelChange)="toggleCheckbox(q, 'reviewee', opt.value, $event)"></vc-checkbox>

                           <div
                              *ngIf="q.hasOther"
                              class="other-inline">
                              <vc-checkbox
                                 label="Other"
                                 [disabled]="!canEdit('reviewee') || isLimitReached(q, 'reviewee', '__other__')"
                                 [ngModel]="isOtherSelected(q.id, 'reviewee')"
                                 (ngModelChange)="toggleOtherSelected(q, 'reviewee', $event)"></vc-checkbox>

                              <vc-text-input
                                 *ngIf="isOtherSelected(q.id, 'reviewee')"
                                 class="other-inline-input"
                                 [label]="''"
                                 [disabled]="!canEdit('reviewee')"
                                 [required]="isOtherSelected(q.id, 'reviewee')"
                                 [maxlength]="q.otherText?.maxLength || 500"
                                 [ngModel]="getOtherText(q.id, 'reviewee')"
                                 (ngModelChange)="setOtherText(q.id, 'reviewee', $event)"></vc-text-input>
                           </div>
                        </div>

                        <vc-textarea
                           *ngIf="q.notes?.revieweeLabel"
                           [id]="'notes_' + section.id + '_' + q.id"
                           [label]="getNotesLabel(q, 'reviewee')"
                           [required]="shouldRequireNotes(q, 'reviewee')"
                           [disabled]="!canEdit('reviewee')"
                           placeholder="Additional comments..."
                           [maxlength]="q.notes.maxLength || 500"
                           [ngModel]="getNotes(q.id, 'reviewee')"
                           (ngModelChange)="setNotes(q.id, 'reviewee', $event)"></vc-textarea>
                     </div>

                     <!-- TEXTAREA (standalone) -->
                     <div
                        class="item-group-assessment"
                        *ngIf="q.type === 'textarea' && hasText(q.revieweeLabel)">
                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewee')"></div>
                        <vc-textarea
                           [id]="'ta_' + section.id + '_' + q.id + '_reviewee'"
                           [label]="!q.labelIsHtml ? questionLabel(q, 'reviewee') : ''"
                           [disabled]="!canEdit('reviewee')"
                           [required]="q.required"
                           placeholder="Additional comments..."
                           [maxlength]="q.maxLength || 500"
                           [ngModel]="getValue(q.id, 'reviewee')"
                           (ngModelChange)="setValue(q.id, 'reviewee', $event)"></vc-textarea>
                     </div>

                     <!-- EXTRA CRITERIA -->
                     <div
                        class="item-group-assessment"
                        *ngIf="q.type === 'criteriaList' && hasText(q.revieweeLabel)">
                        <div
                           class="mb-4"
                           *ngFor="let row of getCriteriaRows(q.id, 'reviewer'); let i = index; trackBy: trackByRowIndex">
                           <vc-radio-group
                              [id]="'criteria_reviewee_' + q.id + '_' + i"
                              [groupName]="'criteria_reviewee_' + q.id + '_' + i"
                              direction="row"
                              [required]="q.required"
                              [disabled]="!canEdit('reviewee')"
                              [radiobutton]="true"
                              [label]="row.title || 'Criteria ' + (i + 1)"
                              [options]="q.options"
                              [ngModel]="row.revieweeRating"
                              (ngModelChange)="setCriteriaCell(q, 'reviewer', i, 'revieweeRating', $event)"></vc-radio-group>
                           <div style="height: 5px"></div>
                           <vc-textarea
                              [label]="criteriaRequiresNotes(row.revieweeRating) ? 'Please explain why' : 'Optional notes'"
                              [required]="criteriaRequiresNotes(row.revieweeRating)"
                              placeholder="Additional comments..."
                              [disabled]="!canEdit('reviewee')"
                              [maxlength]="1000"
                              [ngModel]="row.revieweeNotes"
                              (ngModelChange)="setCriteriaCell(q, 'reviewer', i, 'revieweeNotes', $event)"></vc-textarea>
                        </div>
                     </div>
                  </ng-container>
               </ng-container>
            </div>

            <!-- Reviewer column -->
            <div
               *ngIf="mode !== 'reviewee'"
               style="flex: 1"
               class="right">
               <ng-container *ngFor="let section of sectionGroup; trackBy: trackBySectionId">
                  <div
                     class="section-subheader"
                     *ngIf="sectionGroup.length > 1 && section.id !== 'section_clinical_skills_intro' && shouldShowSection(section)">
                     <h4
                        class="review-subtitle"
                        style="margin-bottom: 20px">
                        {{ groupedSectionTitle(section, "reviewer") }}
                     </h4>

                     <button
                        *ngIf="section.allowSectionNotApplicable && canEdit('reviewer')"
                        type="button"
                        class="v-button v-button-md v-green"
                        (click)="markSectionNotApplicable(section, 'reviewer')">
                        Mark Not Applicable
                     </button>
                  </div>

                  <!-- DYNAMIC ADDITIONAL RESPONSIBILITIES - REVIEWER -->
                  <ng-container *ngIf="isAdditionalResponsibilitiesSection(section)">
                     <div
                        class="item-group-assessment"
                        *ngFor="let r of additionalResponsibilities; trackBy: trackByResponsibilityId">
                        <vc-radio-group
                           [id]="'additional_responsibility_reviewer_' + r.id"
                           [groupName]="'additional_responsibility_reviewer_' + r.id"
                           direction="row"
                           [required]="true"
                           [disabled]="!canEdit('reviewer')"
                           [radiobutton]="true"
                           [label]="r.responsibilityText"
                           [options]="performanceOptions"
                           [ngModel]="getValue('additional_responsibility_' + r.id, 'reviewer')"
                           (ngModelChange)="setValue('additional_responsibility_' + r.id, 'reviewer', $event)"></vc-radio-group>
                        <div style="height: 5px"></div>
                        <vc-textarea
                           [label]="additionalResponsibilityRequiresNotes(r.id, 'reviewer') ? 'Please explain why' : 'Optional notes'"
                           [required]="additionalResponsibilityRequiresNotes(r.id, 'reviewer')"
                           [disabled]="!canEdit('reviewer')"
                           placeholder="Additional comments..."
                           [maxlength]="1000"
                           [ngModel]="getNotes('additional_responsibility_' + r.id, 'reviewer')"
                           (ngModelChange)="setNotes('additional_responsibility_' + r.id, 'reviewer', $event)"></vc-textarea>
                     </div>
                  </ng-container>

                  <ng-container *ngFor="let q of section.questions">
                     <!-- STATIC / READ-ONLY TEXT -->
                     <div
                        class="item-group-assessment static-review-text"
                        *ngIf="q.type === 'static' && hasText(q.reviewerLabel)"
                        [innerHTML]="questionLabel(q, 'reviewer')"></div>

                     <!-- TABLE -->
                     <div
                        class="item-group-assessment"
                        *ngIf="q.type === 'table' && hasText(q.reviewerLabel)">
                        <div [innerHTML]="questionLabel(q, 'reviewer')"></div>

                        <table class="review-table development-table">
                           <thead>
                              <tr>
                                 <th
                                    *ngFor="let col of q.tableColumns"
                                    [style.width]="col.field == 'targetCompletionDate' ? '23%' : 'auto'">
                                    {{ col.label }}
                                 </th>
                                 <th></th>
                              </tr>
                           </thead>

                           <tbody>
                              <tr
                                 class="example-row"
                                 *ngIf="q.id == 'development_items'">
                                 <td>The goal, action item, or course the team member will complete.</td>
                                 <td>Why this goal or action item is being assigned.</td>
                                 <td>How success will be measured or how you'll know the goal has been achieved.</td>
                                 <td>The expected date the goal or action item will be completed.</td>
                                 <td>Example</td>
                              </tr>
                              <tr
                                 class="example-row"
                                 *ngIf="q.id == 'exploration_items'">
                                 <td>List Course/CE/Action Item</td>
                                 <td>List Reason for Assignment</td>
                                 <td>List Timeline to Complete</td>
                                 <td>Example</td>
                              </tr>
                              <tr *ngFor="let row of getTableRows(q.id, 'reviewer'); let i = index; trackBy: trackByRowIndex">
                                 <td *ngFor="let col of q.tableColumns">
                                    <vc-textarea
                                       *ngIf="col.type === 'textarea'"
                                       [label]="''"
                                       [rows]="2"
                                       [disabled]="!canEdit('reviewer')"
                                       [ngModel]="getTableCell(q.id, 'reviewer', i, col.field)"
                                       (ngModelChange)="setTableCell(q.id, 'reviewer', i, col.field, $event)"></vc-textarea>

                                    <vc-text-input
                                       *ngIf="col.type === 'text'"
                                       [label]="''"
                                       [disabled]="!canEdit('reviewer')"
                                       [ngModel]="getTableCell(q.id, 'reviewer', i, col.field)"
                                       (ngModelChange)="setTableCell(q.id, 'reviewer', i, col.field, $event)"></vc-text-input>

                                    <p-dropdown
                                       *ngIf="col.type === 'select'"
                                       [options]="col.options"
                                       optionLabel="label"
                                       optionValue="value"
                                       placeholder="Select"
                                       [disabled]="!canEdit('reviewer')"
                                       [ngModel]="getTableCell(q.id, 'reviewer', i, col.field)"
                                       (ngModelChange)="setTableCell(q.id, 'reviewer', i, col.field, $event)"></p-dropdown>

                                    <p-datepicker
                                       *ngIf="col.type === 'date'"
                                       appendTo="body"
                                       dateFormat="mm/dd/yy"
                                       [showIcon]="true"
                                       [disabled]="!canEdit('reviewer')"
                                       styleClass="form-input-wrapper"
                                       [ngModel]="getTableCell(q.id, 'reviewer', i, col.field)"
                                       (ngModelChange)="setTableCell(q.id, 'reviewer', i, col.field, $event)"></p-datepicker>
                                 </td>

                                 <td style="width: 40px">
                                    <button
                                       type="button"
                                       class="v-button v-button-sm v-gray"
                                       *ngIf="canEdit('reviewer')"
                                       (click)="removeTableRow(q, 'reviewer', i)">
                                       <i class="fas fa-remove"></i>
                                    </button>
                                 </td>
                              </tr>
                           </tbody>
                        </table>

                        <button
                           type="button"
                           class="v-button v-button-sm v-green mt-2"
                           *ngIf="canEdit('reviewer') && (!q.maxRows || getTableRows(q.id, 'reviewer').length < q.maxRows)"
                           (click)="addTableRow(q, 'reviewer')">
                           Add Row
                        </button>
                     </div>

                     <!-- RADIO -->
                     <div
                        class="item-group-assessment"
                        [attr.id]="section.id + '_' + q.id + '_reviewer'"
                        [class.has-error]="validationErrors.has(modeKey('reviewer', section.id, q.id))"
                        *ngIf="q.type === 'radio' && hasText(q.reviewerLabel)">
                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewer')"></div>
                        <vc-radio-group
                           [id]="'rg_' + section.id + '_' + q.id + '_cos'"
                           direction="row"
                           [required]="q.required"
                           [disabled]="!canEdit('reviewer')"
                           [radiobutton]="true"
                           [groupName]="'reviewer_' + section.id + '_' + q.id"
                           [label]="!q.labelIsHtml ? questionLabel(q, 'reviewer') : ''"
                           [options]="radioOptions(q, 'reviewer')"
                           [ngModel]="getValue(q.id, 'reviewer')"
                           (ngModelChange)="setValue(q.id, 'reviewer', $event)"></vc-radio-group>
                        <div style="height: 5px"></div>
                        <vc-textarea
                           *ngIf="q.notes?.reviewerLabel"
                           [id]="'notes_' + section.id + '_' + q.id + '_cos'"
                           [label]="getNotesLabel(q, 'reviewer')"
                           [required]="shouldRequireNotes(q, 'reviewer')"
                           [disabled]="!canEdit('reviewer')"
                           placeholder="Additional comments..."
                           [maxlength]="q.notes.maxLength || 500"
                           [ngModel]="getNotes(q.id, 'reviewer')"
                           (ngModelChange)="setNotes(q.id, 'reviewer', $event)"></vc-textarea>
                     </div>

                     <!-- CHECKBOX -->
                     <div
                        class="item-group-assessment"
                        [attr.id]="section.id + '_' + q.id + '_reviewer'"
                        [class.has-error]="validationErrors.has(modeKey('reviewer', section.id, q.id))"
                        *ngIf="q.type === 'checkbox' && hasText(q.reviewerLabel)">
                        <div
                           class="vc-label"
                           *ngIf="!q.labelIsHtml">
                           {{ questionLabel(q, "reviewer") }}
                           <span class="required-asterisk">*</span>
                        </div>

                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewer')"></div>

                        <div class="checkbox-grid">
                           <vc-checkbox
                              *ngFor="let opt of q.options"
                              [label]="opt.label"
                              [disabled]="!canEdit('reviewer') || isLimitReached(q, 'reviewer', opt.value)"
                              [ngModel]="isChecked(q.id, 'reviewer', opt.value)"
                              (ngModelChange)="toggleCheckbox(q, 'reviewer', opt.value, $event)"></vc-checkbox>

                           <div
                              *ngIf="q.hasOther"
                              class="other-inline">
                              <vc-checkbox
                                 label="Other"
                                 [disabled]="!canEdit('reviewer') || isLimitReached(q, 'reviewer', '__other__')"
                                 [ngModel]="isOtherSelected(q.id, 'reviewer')"
                                 (ngModelChange)="toggleOtherSelected(q, 'reviewer', $event)"></vc-checkbox>

                              <vc-text-input
                                 *ngIf="isOtherSelected(q.id, 'reviewer')"
                                 class="other-inline-input"
                                 [label]="''"
                                 [disabled]="!canEdit('reviewer')"
                                 [required]="isOtherSelected(q.id, 'reviewer')"
                                 [maxlength]="q.otherText?.maxLength || 500"
                                 [ngModel]="getOtherText(q.id, 'reviewer')"
                                 (ngModelChange)="setOtherText(q.id, 'reviewer', $event)"></vc-text-input>
                           </div>
                        </div>

                        <vc-textarea
                           *ngIf="q.notes?.reviewerLabel"
                           [id]="'notes_' + section.id + '_' + q.id"
                           [label]="getNotesLabel(q, 'reviewer')"
                           [required]="shouldRequireNotes(q, 'reviewer')"
                           [disabled]="!canEdit('reviewer')"
                           placeholder="Additional comments..."
                           [maxlength]="q.notes.maxLength || 500"
                           [ngModel]="getNotes(q.id, 'reviewer')"
                           (ngModelChange)="setNotes(q.id, 'reviewer', $event)"></vc-textarea>
                     </div>

                     <!-- TEXTAREA (standalone) -->
                     <div
                        class="item-group-assessment"
                        *ngIf="q.type === 'textarea' && hasText(q.reviewerLabel)">
                        <div
                           class="vc-label"
                           *ngIf="q.labelIsHtml"
                           [innerHTML]="questionLabel(q, 'reviewer')"></div>
                        <vc-textarea
                           [id]="'ta_' + section.id + '_' + q.id + '_reviewer'"
                           [label]="!q.labelIsHtml ? questionLabel(q, 'reviewer') : ''"
                           [disabled]="!canEdit('reviewer')"
                           [required]="q.required"
                           placeholder="Additional comments..."
                           [maxlength]="q.maxLength || 500"
                           [ngModel]="getValue(q.id, 'reviewer')"
                           [class.textarea-height]="includeCareerExploration && sectionGroup[0].id == 'section_growth_and_career_path'"
                           (ngModelChange)="setValue(q.id, 'reviewer', $event)"></vc-textarea>
                     </div>

                     <!-- EXTRA CRITERIA -->
                     <div
                        class="item-group-assessment"
                        *ngIf="q.type === 'criteriaList' && hasText(q.reviewerLabel)">
                        <button
                           type="button"
                           class="v-button v-button-md v-green mb-3"
                           *ngIf="canEdit('reviewer') && (!q.maxRows || getCriteriaRows(q.id, 'reviewer').length < q.maxRows)"
                           (click)="addCriteria(q, 'reviewer')">
                           Add Criteria
                        </button>

                        <div
                           style="margin-bottom: 50px"
                           *ngIf="getCriteriaRows(q.id, 'reviewer').length > 0">
                           <div
                              class="criteria-subsection"
                              *ngFor="let row of getCriteriaRows(q.id, 'reviewer'); let i = index; trackBy: trackByRowIndex">
                              <div class="section-subheader">
                                 <h4 class="review-subtitle"></h4>
                                 <button
                                    type="button"
                                    class="v-button v-button-sm v-gray"
                                    *ngIf="canEdit('reviewer')"
                                    (click)="removeCriteria(q, 'reviewer', i)">
                                    <i class="fas fa-remove"></i>
                                    &nbsp;Remove
                                 </button>
                              </div>
                              <vc-text-input
                                 [label]="'Criteria Description'"
                                 [disabled]="!canEdit('reviewer')"
                                 [ngModel]="row.title"
                                 (ngModelChange)="setCriteriaCell(q, 'reviewer', i, 'title', $event)"></vc-text-input>
                           </div>
                        </div>

                        <div
                           class="mb-4"
                           *ngFor="let row of getCriteriaRows(q.id, 'reviewer'); let i = index; trackBy: trackByRowIndex">
                           <vc-radio-group
                              [id]="'criteria_reviewer_' + q.id + '_' + i"
                              [groupName]="'criteria_reviewer_' + q.id + '_' + i"
                              direction="row"
                              [required]="q.required"
                              [disabled]="!canEdit('reviewer')"
                              [radiobutton]="true"
                              [label]="row.title || 'Criteria ' + (i + 1)"
                              [options]="q.options"
                              [ngModel]="row.reviewerRating"></vc-radio-group>
                           <div style="height: 5px"></div>
                           <vc-textarea
                              [label]="criteriaRequiresNotes(row.reviewerRating) ? 'Please explain why' : 'Optional notes'"
                              [required]="criteriaRequiresNotes(row.reviewerRating)"
                              placeholder="Additional comments..."
                              [disabled]="!canEdit('reviewer')"
                              [maxlength]="1000"
                              [ngModel]="row.reviewerNotes"></vc-textarea>
                        </div>
                     </div>
                  </ng-container>
               </ng-container>
            </div>
         </div>
      </vc-rounded-card>
   </div>
</div>

<!-- PRINT VERSION -->
<div
   class="print-only"
   *ngIf="template?.sections?.length">
   <ng-container *ngFor="let section of template.sections; trackBy: trackBySectionId">
      <div
         class="print-section"
         [class.reviewee-side]="mode === 'reviewee' ? true : false"
         [class.reviewer-side]="mode === 'reviewer' ? true : false"
         *ngIf="shouldShowSection(section) && (canEditReviewee || section.id !== 'section_job_description')">
         <div class="print-section-header">
            <h3
               *ngIf="mode === 'reviewee'"
               style="color: #00a977">
               {{ sectionTitle(section, "reviewee") }}
            </h3>
            <h3
               *ngIf="mode === 'reviewer'"
               [style.color]="section.reviewerTitle ? '#0c76bd' : ''">
               {{ sectionTitle(section, "reviewer") }}
            </h3>
            <h3 *ngIf="mode === 'merged'">{{ sectionTitle(section, "reviewee") }} / {{ sectionTitle(section, "reviewer") }}</h3>
         </div>

         <ng-container *ngFor="let q of section.questions">
            <div
               class="print-qa mb-5 mt-3"
               *ngIf="q.type === 'static' ? true : mode === 'reviewee' ? hasText(q.revieweeLabel) : hasText(q.reviewerLabel)">
               <div
                  *ngIf="q.type === 'static'"
                  class="print-q mt-3"
                  [innerHTML]="questionLabel(q, mode === 'reviewer' ? 'reviewer' : 'reviewee')"></div>
               <div
                  *ngIf="q.type !== 'static'"
                  class="print-q mt-3"
                  [class.reviewer-title]="mode !== 'reviewee' ? true : false">
                  <div
                     class="vc-label"
                     *ngIf="q.labelIsHtml"
                     [innerHTML]="questionLabel(q, mode === 'reviewer' ? 'reviewer' : 'reviewee')"></div>
                  <div
                     class="vc-label"
                     *ngIf="!q.labelIsHtml">
                     {{ questionLabel(q, mode === "reviewer" ? "reviewer" : "reviewee") }}
                  </div>
               </div>

               <!-- Reviewee answer -->
               <div
                  *ngIf="q.type !== 'static' && mode !== 'reviewer'"
                  class="print-a">
                  {{ formatAnswer(q, "reviewee") }}
               </div>

               <!-- Reviewer answer -->
               <div
                  *ngIf="q.type !== 'static' && mode !== 'reviewee'"
                  class="print-a">
                  <span class="print-who">{{ getReviewerLabel(true) }}:</span>
                  &nbsp;
                  <span [innerHTML]="formatAnswer(q, 'reviewer')"></span>
               </div>

               <!-- Notes / Feedback (only show if present) -->
               <div
                  *ngIf="q.type !== 'static' && mode !== 'reviewer' && (getNotes(q.id, 'reviewee') || '').trim()"
                  class="print-notes">
                  <span class="print-who">Feedback:</span>
                  {{ getNotes(q.id, "reviewee") }}
               </div>

               <div
                  *ngIf="q.type !== 'static' && mode !== 'reviewee' && (getNotes(q.id, 'reviewer') || '').trim()"
                  class="print-notes">
                  <span class="print-who">Feedback:</span>
                  {{ getNotes(q.id, "reviewer") }}
               </div>
            </div>
         </ng-container>
      </div>
   </ng-container>
</div>
